/* eslint no-console:0 */
import API from './apiCalls';
import { logLevels, logEvents } from '../constants/appConstants';
import logger from './logger';
import { errorHandlerForClass } from './errorHandler';

/**
 * @description Exchange token (used only in class components like DataProvider)
 * @param {Function} navigate - navigation function passed to class component
 */
const exchangeToken = async(navigate) => {
    const oauthPayload = {
        grant_type: 'client_token',
        client_id: 'dashboard',
    };

    const url = API.endpoint.oauth;
    logger(logLevels.DEBUG, {
        source: 'DataProvider.exchangeToken',
        action: logEvents.API_CALL,
        payload: { url },
    });

    try {
        const response = await new Promise((resolve, reject) => {
            API.post(url, oauthPayload, (res, err) => {
                if (err) reject(err);
                else resolve(res);
            });
        });

        logger(logLevels.DEBUG, {
            source: 'DataProvider.exchangeToken',
            action: logEvents.API_CALL,
            payload: { url, response },
        });

        return response.access_token;
    } catch (error) {
        errorHandlerForClass({
            Message: 'Already used token',
            Exception: (error instanceof Error) ? error.toString() : `${JSON.stringify(error)}`,
        }, true, navigate);

        return null;
    }
};

export default exchangeToken;
